"use client";

import type { ImageLoaderProps } from "next/image";

export default function imageLoader({ src, width }: ImageLoaderProps) {
  return `${src}?w=${width}`;
}
